function flagIsTrue(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

export function sortDebtorsPrimaryFirst(debtors = []) {
  return [...(Array.isArray(debtors) ? debtors : [])].sort((left, right) => {
    const primaryDifference = Number(flagIsTrue(right?.is_primary))
      - Number(flagIsTrue(left?.is_primary));
    if (primaryDifference) return primaryDifference;
    return String(left?.id || '').localeCompare(String(right?.id || ''));
  });
}

export function filingDebtors(debtors = []) {
  return sortDebtorsPrimaryFirst(debtors).filter(
    (debtor) => ![false, 0, '0', 'false'].includes(debtor?.is_filing),
  );
}

export function primaryDebtor(debtors = [], { filingOnly = false } = {}) {
  const ordered = filingOnly ? filingDebtors(debtors) : sortDebtorsPrimaryFirst(debtors);
  return ordered.find((debtor) => flagIsTrue(debtor?.is_primary)) || ordered[0] || null;
}

export function secondaryFilingDebtor(debtors = []) {
  return filingDebtors(debtors).find((debtor) => !flagIsTrue(debtor?.is_primary)) || null;
}

export function debtorFullName(debtor) {
  return [
    debtor?.first_name,
    debtor?.second_name || debtor?.middle_name,
    debtor?.last_name,
    debtor?.suffix,
  ].filter(Boolean).join(' ').trim();
}

export function filingDebtorNames(debtors = [], separator = ' & ') {
  return filingDebtors(debtors).map(debtorFullName).filter(Boolean).join(separator);
}

export function debtorRoleLabel(debtor, debtors = []) {
  const filing = filingDebtors(debtors);
  const filingIndex = filing.findIndex(
    (candidate) => String(candidate?.id) === String(debtor?.id),
  );
  if (filingIndex >= 0) return `Debtor ${filingIndex + 1}`;
  return 'Non-filing spouse';
}
